<script setup lang="ts">
import Settings from "@/views/playground/planner/business-management/settlement-management/Settings.vue";
</script>

<template>
  <settings></settings>
</template>

<style scoped></style>
